/**
 * Kollez rule: `DD MMM YYYY` on all data screens (Indian norm), never `MM/DD/YYYY`.
 * Timezone default `Asia/Kolkata` for the whole product.
 */
const DD_MMM_YYYY = new Intl.DateTimeFormat('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'Asia/Kolkata',
});
const DD_MMM = new Intl.DateTimeFormat('en-IN', {
    day: '2-digit',
    month: 'short',
    timeZone: 'Asia/Kolkata',
});
const HH_MM = new Intl.DateTimeFormat('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Asia/Kolkata',
});
export function formatIndianDate(d) {
    if (d == null)
        return '—';
    const date = typeof d === 'string' ? new Date(d) : d;
    if (Number.isNaN(date.getTime()))
        return '—';
    return DD_MMM_YYYY.format(date);
}
export function formatShortDate(d) {
    if (d == null)
        return '—';
    const date = typeof d === 'string' ? new Date(d) : d;
    if (Number.isNaN(date.getTime()))
        return '—';
    return DD_MMM.format(date);
}
export function formatTime(d) {
    if (d == null)
        return '—';
    const date = typeof d === 'string' ? new Date(d) : d;
    if (Number.isNaN(date.getTime()))
        return '—';
    return HH_MM.format(date);
}
//# sourceMappingURL=date.js.map